import { reactive } from 'vue';

// Read-only "Job Details" preview shown when a job is clicked, BEFORE the edit
// form — mirrors v1's Job Details view. Singleton reactive state + a single
// <JobDetailModal /> mounted in App.vue (same pattern as job-form-modal.ts).
export interface JobDetailModalState {
  isOpen: boolean;
  job: Record<string, any> | null;
}

export const jobDetailModal = reactive<JobDetailModalState>({
  isOpen: false,
  job: null,
});

export function openJobDetail(job: Record<string, any>): void {
  jobDetailModal.job = job;
  jobDetailModal.isOpen = true;
}

export function closeJobDetail(): void {
  jobDetailModal.isOpen = false;
  jobDetailModal.job = null;
}
